import { onlyView } from '@/utils/onlyView.js'
import Path from '@antv/g2/lib/geometry/path';
var newWin = function(href, id,atr) {
	//为防止window.open被浏览器拦截，此处使用a标签打开
	var a = document.createElement('a');
	a.setAttribute('href', href);
	a.setAttribute('target', 'view_'+atr);
	a.setAttribute('id', id);
	// 防止反复添加
	if(!document.getElementById(id)) document.body.appendChild(a);
	a.click();
	setTimeout(()=>{
		document.body.removeChild(a);
	},100)
};
// 设置单页面公共部分
export default {
	computed: {
		getOnlyView() {
			return onlyView;
		},
	},
	methods: {
		/**
		 * 设置localStorage 
		 *	@param {string} atr 需储存的属性
		 */
		changeStroge(atr) {
			// 设置动态 localStorage属性值 用于监听
			localStorage.setItem(atr, this.$route.path + ',' + new Date().getTime());
		},
		/**
		 * 设置localStorage 并打开页面
		 *	@param {string} path 需打开的页面路径
		 *	@param {string} atr 需储存的属性
		 */
		openAndSetView(path, atr) {
			let { href } = this.$router.resolve({
				path: path,
			});
			// console.log('href0',href);
			// console.log('path0',path);
			// if(!String(href).includes(Path)){
			// 	href = path;
			// 	if(String(href)[0]!='#'){
			// 		href = '#'+href;
			// 	}
			// }
			console.log('href',href);
			console.log('path',path);
			// window.open(href, "view_" + atr);
			newWin(href,new Date().getTime(),atr);
			// console.log('atr', atr);
			// 设置动态 localStorage 属性值 用于监听
			localStorage.setItem(atr, this.$route.path + ',' + new Date().getTime());
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/mixin/onlyViewMixin.js